export default __webpack_public_path__ + "static/media/2.7f0693aa.png";